require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-msa-jao-stargazing.json") })
        }
      }, "path---blog-msa-jao-stargazing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-msa-jao-stargazing!./.cache/json/blog-msa-jao-stargazing.json
// module id = 382
// module chunks = 231608221292675